import { render, staticRenderFns } from "./AddressField.vue?vue&type=template&id=c2b08226&"
import script from "./AddressField.vue?vue&type=script&lang=js&"
export * from "./AddressField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports